__turbopack_context__.v({
  "className": "outfit_faf46ab7-module__v26ulG__className",
  "variable": "outfit_faf46ab7-module__v26ulG__variable",
});
